const uniqueDriversReport = {
  table: {
    headers: {
      date: 'Fecha',
      uniqueDrivers: 'Conductores únicos',
    },
    tableDetails: {
      headers: {
        date: 'Fecha',
        uniqueDrivers: 'Conductores únicos',
        driver: 'Conductor',
        trips: 'Viajes',
      },
    },
  },
  actions: {
    export: 'Exportar',
  },
};

export default uniqueDriversReport;
